import moment from 'moment';
export default function createDaysArray(month, year, minimumDate, maximumDate, disabledDates, disabledDays) {
  const daysInMonth = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();
  const padLeft = moment(`${year}-${month}-01`, 'YYYY-MM-DD').isoWeekday() - 1;
  const padRight = 7 - moment(`${year}-${month}-${daysInMonth}`, 'YYYY-MM-DD').isoWeekday();
  const prevMonthDate = moment(`${year}-${month}-01`, 'YYYY-MM-DD').subtract(1, 'month');
  const daysPrevMonth = prevMonthDate.daysInMonth();
  const minimumMoment = moment(minimumDate, 'YYYY-MM-DD');
  const maximumMoment = moment(maximumDate, 'YYYY-MM-DD');

  const generateDateObject = (dateString, state) => {
    const dateMoment = moment(dateString, 'YYYY-MM-DD');

    if (!dateMoment.isValid()) {
      return null;
    }

    return {
      state,
      date: {
        year: dateMoment.format('YYYY'),
        month: dateMoment.format('MM'),
        day: dateMoment.format('D'),
        dateString
      }
    };
  };

  const daysArray = [...Array.from({
    length: padLeft
  }, (_, i) => {
    const day = daysPrevMonth - padLeft + i + 1;
    const dateString = prevMonthDate.clone().date(day).format('YYYY-MM-DD');
    return generateDateObject(dateString, 'disabled');
  }).filter(Boolean), ...Array.from({
    length: daysInMonth
  }, (_, i) => {
    const day = i + 1;
    const dateString = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const dateMoment = moment(dateString, 'YYYY-MM-DD');
    const allowed = dateMoment.isBetween(minimumMoment, maximumMoment, 'days', '[]');
    const isDisabledDate = disabledDates.some(date => moment(date, 'YYYY-MM-DD').isSame(dateMoment, 'day'));
    const isDisabledDay = disabledDays.includes(dateMoment.isoWeekday());
    const state = moment().isSame(dateMoment, 'day') ? 'today' : !allowed || isDisabledDate || isDisabledDay ? 'disabled' : 'active';
    return generateDateObject(dateString, state);
  }).filter(Boolean), ...Array.from({
    length: padRight
  }, (_, i) => {
    const nextMonthDate = moment(`${year}-${month}-01`, 'YYYY-MM-DD').add(1, 'month');
    const day = i + 1;
    const dateString = nextMonthDate.clone().date(day).format('YYYY-MM-DD');
    return generateDateObject(dateString, 'disabled');
  }).filter(Boolean)];
  return daysArray;
}
//# sourceMappingURL=create-days-array.js.map